<template>
  <b-container>
    <b-row>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row>
    <h2>{{ $t("tracking.cargoExpenseOccurrence.list") }}</h2>

    <b-row>
      <router-link :to="getUrlCreate()">
        <b-button size="sm">{{ $t("geral.create") }}</b-button>
      </router-link>
    </b-row>

    <b-row>
      <b-table
        ref="table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
        <template v-slot:cell(actions)="data">
          <router-link :to="getUrlEdit(data.item)">
            <b-button size="sm" class="btn-checklist">
              {{ $t("geral.edit") }}
            </b-button>
          </router-link>
          <b-button
            v-if="isOccurrenceTypeActive(data.item)"
            size="sm"
            class="btn-checklist ml-2"
            @click="occurrenceTypeDeactivate(data.item)"
            >{{ $t("geral.delete") }}</b-button
          >
          <b-button
            v-else
            size="sm"
            class="btn-checklist ml-2"
            @click="occurrenceTypeActivate(data.item)"
            >{{ $t("geral.activate") }}</b-button
          >
        </template>
        <template v-slot:cell(ativo)="data">
          {{ data.value ? "Sim" : "Não" }}
        </template>
      </b-table>
    </b-row>

    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>
  </b-container>
</template>
<script>
import TablePaginationProps from "@/components_rms/base/TablePaginationProps.vue";
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";

export default {
  name: "CargoExpenseOccurrenceList",
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
    TablePaginationProps,
  },
  data: function () {
    return {
      alert: {
        error: "",
        success: "",
      },
      isBusy: false,
      fields: [
        {
          key: "actions",
          sortable: false,
          label: "",
          tdClass: "table-col-dinamic-width",
          // thStyle: "max-width: 10px; min-width: 10px;",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "sequenceNumber",
          filterKey: "sequenceNumber",
          label: this.$t("tracking.cargoExpenseOccurrence.model.sequenceNumber"),
          // thStyle: "max-width: 10px; min-width: 10px;",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "description",
          filterKey: "description",
          label: this.$t("tracking.cargoExpenseOccurrence.model.description"),
          thStyle: "min-width: 75px;",
          // tdClass: "table-col-dinamic-width",
        },
        {
          key: "active",
          filterKey: "active",
          label: this.$t("geral.active"),
          sortable: true,
          formatter: (value, key, item) => {
            if (value) {
              return "Sim";
            }
            return "Não";
          },
          // thStyle: "max-width: 5px; min-width: 5px;",
          tdClass: "table-col-dinamic-width",
          // thStyle: "max-width: 15px; min-width: 15px;",
        },
      ],
      computed: {},
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      tableFilters: {
        description: "",
        sequenceNumber: "",
        active: true,
      },
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  computed: {},
  methods: {
    getUrlCreate() {
      return `/trackingShippingCompany/cargoExpenseOccurrence/Create`;
    },
    getUrlEdit(occurrence) {
      return `/trackingShippingCompany/cargoExpenseOccurrence/edit/${occurrence.id}`;
    },
    isOccurrenceTypeActive(cargoExpenseOccurrence) {
      if (cargoExpenseOccurrence) {
        return cargoExpenseOccurrence.active;
      }
      return true;
    },
    myProvider(ctx, callback) {
      this.isBusy = true;

      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        active: true,
      };
      this.$api
        .post("/v1/cargoExpense/occurrence/list", apiParam)
        .then((response) => {
          const items = response.data.items;
          console.log(items);
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    occurrenceTypeActivate(cargoExpenseOccurrence) {
      this.$api
        .get(
          "v1/CargoExpenseOccurrence/activate/" + cargoExpenseOccurrence.id.toString()
        )
        .then((response) => {
          // console.log("entrou");
          cargoExpenseOccurrence.active = true;
          this.alert.success = response.data.title;
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(error.response);
          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
    occurrenceTypeDeactivate(cargoExpenseOccurrence) {
      this.$api
        .get(
          "v1/CargoExpenseOccurrence/Deactivate/" + cargoExpenseOccurrence.id.toString()
        )
        .then((response) => {
          // console.log("entrou");
          cargoExpenseOccurrence.active = false;
          this.alert.success = response.data.title;
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(`error: ${error}`);
          console.log(error);
          console.log(`error.response: ${error.response}`);
          console.log(error.response);

          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
  },
};
</script>
